import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from '../_services/home.service';
import { Footer, FooterContent } from '../_model/footer';
import { QuickLink } from '../_model/quicklink';
import { GuidedHelp } from '../_model/guidedhelp';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
export let checkCaseModalInHome = false;
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
@Component({
  selector: "app-quick-links",
  templateUrl: "./quick-links.component.html",
  styleUrls: ["./quick-links.component.scss"],
})
export class QuickLinksComponent implements OnInit {
  contact: Footer = {};
  contactDetails: FooterContent = {};
  quickLinksContent: QuickLink = {};
  col4Links = [];
  col3Links = [];
  mobileLinks = [];
  count: number;
  helpTopics: GuidedHelp = {};
  @Input() topArticle;
  articleTitle: any;
  ghTopic: String;
  ghBrowseAll: String;
  ghTitle: any;
  ghDisableTopic: boolean;
  helpTopic: any = [];
  contactTitle: any;
  checkCaseModalInHome: boolean = false;
  isSmartViewChat: any;
  disableLiveChatSHP: any;
  constructor(
    private homeService: HomeService,
    private gaService : GoogleAnalyticsService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.homeService.getShpLogin().subscribe(res=>{
      this.isSmartViewChat=res.return_body.is_smart_view_chat;
      this.disableLiveChatSHP = res.return_body.disable_live_chat_SHP
      })
    this.getContactDetails();
    this.getQuickLinks();
    this.getHelpTopics();
    this.getTopArticlesTitle();
    this.getGdHelp();
  }

  getTopArticlesTitle() {
    this.homeService.getTopArticleTitle().subscribe((res) => {
      this.articleTitle = res.return_body.title;
    });
  }
  getContactDetails() {
    this.homeService.getFooterConfig().subscribe((res) => {
      if(res.return_body.contactTitle==null || res.return_body.contactTitle=="" ){
        this.contactTitle = "Contact Us"
    }
      else{
      
      this.contactTitle = res.return_body.contactTitle;
      } 
      this.contact = res.return_body;
      this.contact.footerText.forEach((data) => {
        switch (data.key) {
          case "Call number":
            this.contactDetails.callNumber = data.text;
            break;
          case "Call number content":
            this.contactDetails.callNumberContent = data.text;
            this.contactDetails.callNumberIcon = data.type;
            break;
          case "Call number2":
            this.contactDetails.callNumber2 = data.text;
            break;
          case "Call number content2":
            this.contactDetails.callNumberContent2 = data.text;
            this.contactDetails.callNumberIcon2 = data.type;
            break;
          case "Call number3":
              this.contactDetails.callNumber3 = data.text;
              break; 
          case "Call number content3":
              this.contactDetails.callNumberContent3 = data.text;
              this.contactDetails.callNumberIcon3 = data.type;
              break;
          case "Call number4":
              this.contactDetails.callNumber4 = data.text;
              break;
          case "Call number content4":
              this.contactDetails.callNumberContent4 = data.text;
              this.contactDetails.callNumberIcon4 = data.type;
              break;     
          case "Call number5":
              this.contactDetails.callNumber5 = data.text;
              break;
          case "Call number content5":
              this.contactDetails.callNumberContent5 = data.text;
              this.contactDetails.callNumberIcon5 = data.type;
              break;                                           
          case "Chat":
            this.contactDetails.chatContent = data.text;
            this.contactDetails.chatIcon = data.type;
            break;
          case "Create case title":
            this.contactDetails.createCase = data.text;
            this.contactDetails.createCaseIcon = data.type;
            break;
          case "Additional Info":
              this.contactDetails.additionalInfo = data.text;
            break;
        }
      });
    });
  }
  getGdHelp() {
    this.homeService.getGuidedHelp().subscribe((res) => {
      this.ghTopic = res.return_body.ghTopic;
      this.ghBrowseAll = res.return_body.ghBrowseAll;
      this.ghTitle = res.return_body.ghTitle;
      this.ghDisableTopic = res.return_body.ghDisableTopic;
    });
  }
  getQuickLinks() {
    this.homeService.getQuickLinks().subscribe((res) => {
      this.quickLinksContent = res.return_body;
      this.count = 0;
      this.quickLinksContent.quickLink.forEach((response) => {
        if (response.enable) {
          this.count = this.count + 1;
          this.mobileLinks.push(response);
        }
      });
      if (this.count === 4 || this.count > 6) {
        this.quickLinksContent.quickLink.forEach((response) => {
          if (response.enable) {
            this.col4Links.push(response);
          }
        });
      } else {
        this.quickLinksContent.quickLink.forEach((response) => {
          if (response.enable) {
            this.col3Links.push(response);
          }
        });
      }
    });
  }

  getHelpTopics() {
    let totalTopics = [];
    this.homeService.getHelpTopics().subscribe((res) => {
      this.helpTopics = res.return_body;
      if (res.return_body.length > 10) {
        for (let i = 0; i < 10; i++) {
          totalTopics = this.helpTopics[i];
          this.helpTopic = this.helpTopic.concat(totalTopics);
        }
      } else {
        for (let i = 0; i < res.return_body.length; i++) {
          totalTopics = this.helpTopics[i];
          this.helpTopic = this.helpTopic.concat(totalTopics);
        }
      }
    });
  }
  openChat(){
    this.homeService.openChat.next(true);
  }
  navigate(pk) {
    this.router.navigate(
      ["/" + this.router.url.split("/")[1] + "/helptopics"],
      { queryParams: { PK: pk } }
    );
  }
  handleNavigation(pathValue) {
    if (pathValue === 'createcase') {
      this.checkCaseModalInHome = true;
  }
  else{
    this.router.navigate([this.router.url.split("/")[1], pathValue]);
  }
  }
  handleNavigate(pathValue) {
    if (pathValue == "case") {
      // this.router.navigate([this.router.url.split("/")[1], "createcase"]);
      this.checkCaseModalInHome = true;
    }
    if (pathValue == 'chat') {
      this.router.navigate([this.router.url.split("/")[1],'chat-user-interface']);
    }
  }

  checkIsCaseModalOpen(event){
    this.checkCaseModalInHome = false;
  }
}
